import React from 'react';
import './BannerBookingsAndAgents.scss';
import Button from 'Components/Shared/Button/Button';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  agentsContent: Julius.Content.Banner;
  bookingsContent: Julius.Content.Banner;
  localPathBookings: string;
  localPathAgents: string;
}

const BannerBookingsAndAgents: React.SFC<IProps> = ({
  agentsContent,
  bookingsContent,
  localPathBookings,
  localPathAgents,
}) => {

  if (!agentsContent || !bookingsContent) {
    return null;
  }
  
  return (
    <WrapperLayout style='banner-bookings-agents'>
      <Box localPath={ localPathBookings } { ...bookingsContent } />
      <Box localPath={ localPathAgents } { ...agentsContent } />
    </WrapperLayout>
  );
};

const Box: React.SFC<{
  title: string;
  text: string;
  imageUrl: string;
  localPath: string;
}> = ({
  title,
  text,
  imageUrl,
  localPath,
}) => (
  <div className='box'>
    <img alt='Publik på konsert' src={ imageUrl } />
    <span className='title'>{ title }</span>
    <span className='text' dangerouslySetInnerHTML={ { __html: text } } />
    <Button localPath={ localPath } color='black'>
      <FormattedText
        displayName='Mer information'
        formattedName='global.moreinfo'
      />
    </Button>
  </div>
);

export default BannerBookingsAndAgents;


// WEBPACK FOOTER //
// ./src/components/BannerBookingsAndAgents/BannerBookingsAndAgents.tsx